function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { filterProps } from '@mantine/styles';
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return target;
};
function extractSystemStyles(others) {
  var _a = others,
    m = _a.m,
    mx = _a.mx,
    my = _a.my,
    mt = _a.mt,
    mb = _a.mb,
    ml = _a.ml,
    mr = _a.mr,
    p = _a.p,
    px = _a.px,
    py = _a.py,
    pt = _a.pt,
    pb = _a.pb,
    pl = _a.pl,
    pr = _a.pr,
    bg = _a.bg,
    c = _a.c,
    opacity = _a.opacity,
    ff = _a.ff,
    fz = _a.fz,
    fw = _a.fw,
    lts = _a.lts,
    ta = _a.ta,
    lh = _a.lh,
    fs = _a.fs,
    tt = _a.tt,
    td = _a.td,
    w = _a.w,
    miw = _a.miw,
    maw = _a.maw,
    h = _a.h,
    mih = _a.mih,
    mah = _a.mah,
    bgsz = _a.bgsz,
    bgp = _a.bgp,
    bgr = _a.bgr,
    bga = _a.bga,
    pos = _a.pos,
    top = _a.top,
    left = _a.left,
    bottom = _a.bottom,
    right = _a.right,
    inset = _a.inset,
    display = _a.display,
    rest = __objRest(_a, ["m", "mx", "my", "mt", "mb", "ml", "mr", "p", "px", "py", "pt", "pb", "pl", "pr", "bg", "c", "opacity", "ff", "fz", "fw", "lts", "ta", "lh", "fs", "tt", "td", "w", "miw", "maw", "h", "mih", "mah", "bgsz", "bgp", "bgr", "bga", "pos", "top", "left", "bottom", "right", "inset", "display"]);
  var systemStyles = filterProps({
    m: m,
    mx: mx,
    my: my,
    mt: mt,
    mb: mb,
    ml: ml,
    mr: mr,
    p: p,
    px: px,
    py: py,
    pt: pt,
    pb: pb,
    pl: pl,
    pr: pr,
    bg: bg,
    c: c,
    opacity: opacity,
    ff: ff,
    fz: fz,
    fw: fw,
    lts: lts,
    ta: ta,
    lh: lh,
    fs: fs,
    tt: tt,
    td: td,
    w: w,
    miw: miw,
    maw: maw,
    h: h,
    mih: mih,
    mah: mah,
    bgsz: bgsz,
    bgp: bgp,
    bgr: bgr,
    bga: bga,
    pos: pos,
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    inset: inset,
    display: display
  });
  return {
    systemStyles: systemStyles,
    rest: rest
  };
}
export { extractSystemStyles };